module.exports = __webpack_public_path__ + "img/paso4.d3178095.svg";